export class ClassInterfacesCache {
  // "ClassA": { interfaces: [ “...”, “...” ] },
  private static CACHE: Map<string, { interfaces: string[]; type: string }> = new Map<
    string,
    { interfaces: string[]; type: string }
  >();

  static getClassInterfaces(classId: string): { interfaces: string[]; type: string } {
    return ClassInterfacesCache.CACHE.get(classId);
  }

  static setClassInterfaces(classId: string, interfaces: string[], type: string): void {
    ClassInterfacesCache.CACHE.set(classId, { interfaces, type });
  }
}
